module.exports = __webpack_public_path__ + "static/media/Comavix.3b6bf269.png";